import React from 'react'
import DirectoriesContainer from '../../component/DirectoriesContainer/DirectoriesContainer'

const Home = () => {
  return (
    <DirectoriesContainer />
  )
}

export default Home